import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Evidence } from '../../audit.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'iaud-evidence-edit-form',
  templateUrl: './evidence-edit-form.component.html',
  styleUrls: ['./evidence-edit-form.component.scss']
})
export class EvidenceEditFormComponent implements OnInit {

  evidenceForm: FormGroup;
  myFormData: FormData;
  _file: File;

  set file(val: File) {
    this._file = val;
    this.isValidChange.emit(this.evidenceForm.valid);
    this.fileChanged.emit(this._file);
  }
  get file(): File { return this._file; }

  @Input()
  evidence: Evidence;
  @Input()
  isNew: boolean = false;
  @Output()
  isValidChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  fileChanged: EventEmitter<File> = new EventEmitter<File>();

  constructor(
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.evidenceForm = this.generateForm();
    this.evidenceForm.valueChanges
      .pipe(
        distinctUntilChanged()
      )
      .subscribe(values => {
        this.evidence.description = values.description;
        this.isValidChange.emit(this.evidenceForm.valid);
      });
  }
  generateForm(): FormGroup {
    return this.formBuilder.group({
      description: [this.evidence.description, Validators.maxLength(2000)],
    });
  }
  clearfile(): void {
    this.file = null;
    this.evidence.fileName = null;
  }
}
